import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class MessageClaraDraftClaim extends BaseEntityModel {
  claimId?: string;
  askId?: string;
  text?: string;
  sourceId?: string | null;
  supported?: boolean;
  support?: string | null;
  reason?: string | null;

  constructor(model: Partial<MessageClaraDraftClaim> = {}) {
    super(model);

    this.claimId = model.claimId;
    this.askId = model.askId;
    this.text = model.text;
    this.sourceId = model.sourceId;
    this.supported = model.supported;
    this.support = model.support;
    this.reason = model.reason;
  }
}
